import clsx from 'clsx';
import PdfIcon from 'svg/PdfIcon';
import styles from '../ProductItems.module.css';
import { INTERST_ONLY_BROKERS_URL } from './productGuidesLinks';

export const InterestOnlyFlexiLoan = () => {
  return (
    <div className={styles.content}>
      <h2 className={styles.title}>15 months</h2>
      <p className={styles.intro}>First 3 months interest-only.</p>
      <ul className={styles.benefits}>
        <li className={styles.benefit}>
          <span className={styles.benefitLabel}>Borrow over</span>
          <strong>15 months</strong>
        </li>
        <li className={styles.benefit}>
          <span className={styles.benefitLabel}>Rates from</span>
          <strong>2.00%</strong>
        </li>
        <li className={styles.benefit}>
          <span className={styles.benefitLabel}>Withdrawal fee</span>
          <strong>0%</strong>
        </li>
      </ul>
      <div className={clsx(styles.footer, styles.interestOnlyFooter)}>
        <div>
          <PdfIcon />
        </div>
        <a href={INTERST_ONLY_BROKERS_URL} target="_blank" rel="noreferrer">
          15 months guide
        </a>
      </div>
    </div>
  );
};
